import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function StoryListPage() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    category: '',
    status: '',
    sort: 'created_at'
  });
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    total: 0
  });

  useEffect(() => {
    fetchStories();
  }, [filters, pagination.page]);

  const fetchStories = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: pagination.page.toString(),
        limit: '20',
        ...filters
      });
      
      const response = await fetch(`/api/stories?${params}`);
      const data = await response.json();
      
      if (data.stories) {
        setStories(data.stories);
        setPagination(prev => ({
          ...prev,
          page: data.pagination.page,
          totalPages: data.pagination.totalPages,
          total: data.pagination.total
        }));
      }
    } catch (error) {
      console.error('获取故事列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold">🔥 接力故事</h1>
          <p className="text-gray-400 mt-1">多人协作，共创精彩剧情</p>
        </div>
        <Link
          to="/create"
          className="bg-gradient-to-r from-purple-600 to-primary-600 hover:from-purple-700 hover:to-primary-700 text-white px-6 py-3 rounded-lg font-bold"
        >
          ➕ 开新坑
        </Link>
      </div>

      {/* 筛选器 */}
      <div className="bg-white p-4 rounded-lg shadow-md mb-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-gray-700 mb-2">分类</label>
            <select
              value={filters.category}
              onChange={(e) => handleFilterChange('category', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            >
              <option value="">全部</option>
              <option value="fantasy">奇幻</option>
              <option value="romance">言情</option>
              <option value="sci-fi">科幻</option>
              <option value="mystery">悬疑</option>
              <option value="general">其他</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-700 mb-2">状态</label>
            <select
              value={filters.status}
              onChange={(e) => handleFilterChange('status', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            >
              <option value="">全部</option>
              <option value="ongoing">连载中</option>
              <option value="completed">已完结</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-700 mb-2">排序</label>
            <select
              value={filters.sort}
              onChange={(e) => handleFilterChange('sort', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            >
              <option value="created_at">最新发布</option>
              <option value="updated_at">最近更新</option>
              <option value="views">最多阅读</option>
              <option value="likes">最多喜欢</option>
            </select>
          </div>
        </div>
      </div>

      {/* 故事列表 */}
      {loading ? (
        <div className="text-center py-12">
          <div className="text-gray-500">加载中...</div>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {stories.map(story => (
              <Link
                key={story.id}
                to={`/stories/${story.id}`}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-bold mb-2 text-gray-800">{story.title}</h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{story.description}</p>
                <div className="flex justify-between items-center text-sm text-gray-500">
                  <span>📖 {story.views || 0}</span>
                  <span>❤️ {story.likes || 0}</span>
                  <span className="bg-gray-100 px-2 py-1 rounded">{story.category || '其他'}</span>
                </div>
              </Link>
            ))}
          </div>

          {/* 分页 */}
          {pagination.totalPages > 1 && (
            <div className="flex justify-center mt-8 space-x-2">
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                disabled={pagination.page === 1}
                className="px-4 py-2 border rounded disabled:opacity-50"
              >
                上一页
              </button>
              <span className="px-4 py-2">
                第 {pagination.page} / {pagination.totalPages} 页
              </span>
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                disabled={pagination.page === pagination.totalPages}
                className="px-4 py-2 border rounded disabled:opacity-50"
              >
                下一页
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default StoryListPage;
